module.exports = __webpack_public_path__ + "img/out.2ce6ce24.png";